import { useMemo } from 'react';
import { useLocation } from 'react-router';

import { CenteredContent } from '#/components/CenteredContent/CenteredContent';
import { H1 } from '#/components/Text/H1';
import { ForgotPasswordFormContainer } from '#/containers/ForgotPasswordFormContainer';
import { useQueryParamState } from '#/hooks/useQueryParamState';
import { useTrackPageView } from '#/hooks/useTrackPageView';
import { useI18n } from '#/i18n/hooks/useI18n';

export function AuthForgotPasswordPage() {
  const { i18n } = useI18n();
  const location = useLocation<{ email?: string }>();

  useTrackPageView('Forgot Password', {
    page_type: 'Forgot Password',
  });

  const [emailFromQuery] = useQueryParamState({ name: 'email' });

  const email = useMemo(
    () => emailFromQuery ?? location.state?.email,
    [emailFromQuery, location.state],
  );

  return (
    <CenteredContent>
      <H1 styleAs="h2">
        {
          /* TRANSLATORS: page title when user forgot their password */
          i18n('Reset Password')
        }
      </H1>

      <ForgotPasswordFormContainer
        analyticsTitle="[main] Forgot password page"
        usageContext="page"
        email={email}
      />
    </CenteredContent>
  );
}
